import { getLevelDomain } from '@flinks/utils';
import { isLocal } from './env';

export const DEFAULT_FAVICON =
  'https://s.cdn.ling-shi.com/upload/20220301/9b4195605af54b02b9f205bbe1414ca9.ico';

/**
 * 获取指定cookie domain
 */
function getCookieDomain() {
  // 获取一级域名
  return getLevelDomain(1);
}

/**
 * 获取协议
 */
function getProtocol() {
  return location.protocol;
}

/**
 * 获取企业前缀
 */
function getCompanyPrefix() {
  return document.domain.replace(`.${getCookieDomain()}`, '');
}

/**
 * 获取请求api前缀
 */
export function getApiPrefix() {
  return isLocal() ? '/api' : `${getProtocol()}//${getCompanyPrefix()}.${getCookieDomain()}/api`;
}

export function getBJYOrigin() {
  const origin = isLocal() ? 'http://localhost:3050' : location.origin;
  return `${origin}/bjy-web`;
}

export function getTCOrigin() {
  const origin = isLocal() ? 'http://localhost:3090' : location.origin;
  return `${origin}/links-web`;
}
